module.exports = __webpack_public_path__ + "df83cb59dde920721374fb1fcdaad023.woff";